module.exports = {
  credentials: {
    indexName: 'gamemaster_society',
    appId: 'O3F8QXYK6R',
    apiKey: '9bbf81bebfaa824ad7c471b05e0d7ef9',
  },
  sidebar: [
    {
      title: 'Pathfinder Edition',
      options: {
        attribute: 'ruleVersion',
        sortBy(alpha, beta) {
          return alpha - beta;
        },
        transformItems(items) {
          const hashes = { 1: 'First Edition', 2: 'Second Edition' };
          return items.map((item) => {
            item.highlighted = hashes[item.label];
            return item;
          });
        },
      },
    },
    {
      title: 'Season',
      options: {
        attribute: 'seasonIndex',
        limit: 20,
        sortBy(alpha, beta) {
          return parseInt(alpha.path) - parseInt(beta.path);
        },
        transformItems(items) {
          return items.map((item) => ({
            ...item,
            highlighted: `Season ${item.label}`,
          }));
        },
      },
    },
    {
      title: 'PC Level',
      options: {
        attribute: 'levels',
        limit: 5,
        showMore: true,
        showMoreLimit: 1000,
        sortBy(alpha, beta) {
          return parseInt(alpha.path) - parseInt(beta.path);
        },
        transformItems(items) {
          return items.map((item) => ({
            ...item,
            highlighted: `Level ${item.label}`,
          }));
        },
      },
    },
    {
      title: 'Locations',
      options: {
        attribute: 'locations',
        searchable: true,
        searchablePlaceholder: 'Search for a location...',
        showMore: true,
        showMoreLimit: 1000,
      },
    },
    {
      title: 'NPCs & Factions',
      options: {
        attribute: 'npcs',
        searchable: true,
        searchablePlaceholder: 'Search for a NPC or faction...',
        showMore: true,
        showMoreLimit: 1000,
      },
    },
    {
      title: 'Authors',
      options: {
        attribute: 'authors',
        searchable: true,
        searchablePlaceholder: 'Search for an author...',
        showMore: true,
        showMoreLimit: 1000,
      },
    },
  ],
};
